import { render, staticRenderFns } from "./ProfileAdditionalTraining.vue?vue&type=template&id=4105d6fb&scoped=true"
import script from "./ProfileAdditionalTraining.vue?vue&type=script&lang=js"
export * from "./ProfileAdditionalTraining.vue?vue&type=script&lang=js"
import style0 from "./ProfileAdditionalTraining.vue?vue&type=style&index=0&id=4105d6fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4105d6fb",
  null
  
)

export default component.exports